// Using the browser specific directory router instance to assist builds to be faster
import { Router } from 'director-fork/build/director';
import getBasePath from 'owa-url/lib/getBasePath';

let router = new Router();
export default router;

export function getCurrentRoute() {
    let sections = getBasePath().slice(0, -1).split('/');
    return router.getRoute().slice(sections.length);
}
